import { render, staticRenderFns } from "./IpotekList.vue?vue&type=template&id=a0942c88"
import script from "./IpotekList.vue?vue&type=script&lang=ts"
export * from "./IpotekList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports